import { Injectable } from '@angular/core';

/** Sections whose seat availability failed to load. They must never be shown as available. */
@Injectable({
  providedIn: 'root',
})
export class UnavailableSectionsStore {
  readonly ids = new Set<string>();
}
